import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as CommonConstants from 'src/app/utils/common.constants';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { SharedService } from '../utils/shared.service';
import { UserService } from '../user/user.services';
import { ChangePassword } from '../change-password/change-password';
import { ChangeData } from 'ngx-intl-tel-input/lib/interfaces/change-data';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  authenticated;
  @Output() loginAuthenticate = new EventEmitter<string>();
  loginForm: FormGroup;
  submitted = false;
  partnerType: any;
  resetPswd:ChangePassword=new ChangePassword();
  constructor(public router: Router, private formBuilder: FormBuilder, private sharedService:SharedService,private userService:UserService,private http: HttpClient, private toastrService: ToastrService) {

    this.loginForm = this.formBuilder.group({
      'username': ['', Validators.required],
      'password': ['', Validators.required],
    })
  }

  ngOnInit() {
  }

  get f() { return this.loginForm.controls; }

  login() {
   this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.http.post(CommonConstants.env + 'api/user/authenticate', this.loginForm.value).
      subscribe(response => {
        this.sharedService.setUserOrganismId(null);
        this.sharedService.setUserProfileId(null);
        if (response && response["access_token"]) {
          localStorage.setItem(CommonConstants.ACCESS_TOKEN, response["access_token"]);
          localStorage.setItem(CommonConstants.REFRESH_TOKEN, response["refresh_token"]);
          localStorage.setItem(CommonConstants.EXPIRES_IN, response["expires_in"]);
          localStorage.setItem(CommonConstants.EMPLOYEE_NAME, response["userDetails"]["secUsrLogin"]);
          localStorage.setItem(CommonConstants.PARTNER_TYPE, response["userDetails"]["secUsrLogin"]);
          localStorage.setItem(CommonConstants.SEC_USER_ID, response["userDetails"]["secUsrId"]);
          if(response["userDetails"]["tuSecUserDetail"]["secSubProId"]){
            localStorage.setItem(CommonConstants.PARTNER_TYPE, response["userDetails"]["tuSecUserDetail"]["partnerType"]);
            localStorage.setItem(CommonConstants.PARTNER_ID, response["userDetails"]["tuSecUserDetail"]["partnerId"]);
            this.partnerType=+response["userDetails"]["tuSecUserDetail"]["partnerType"];
            localStorage.setItem(CommonConstants.USER_SUB_PROFILE, response["userDetails"]["tuSecUserDetail"]["secSubProId"]);
              localStorage.setItem(CommonConstants.USER_MENUS, JSON.stringify(response["userMenus"]));
              localStorage.setItem(CommonConstants.USER_PRIVILAGE, JSON.stringify(response["userPrivilages"]));
              this.sharedService.getPrivilages();
              localStorage.setItem(CommonConstants.USER_COUNTRY_ID, response["userDetails"]["tuSecUserDetail"]["cotryIdDefault"]);
              localStorage.setItem(CommonConstants.USER_ORGANISM, response["userDetails"]["tuSecUserDetail"]["orgsmId"]);
          }
         /*  if(response["orgLogo"]!=null){
            localStorage.setItem("ORG_LOGO", response["orgLogo"]);
          } */
          this.loginAuthenticate.emit(this.authenticated)
          if( this.partnerType===2 || this.partnerType===4){
            this.router.navigate(['myspace']);
          }else{
          this.router.navigate(['dashboard']);
          }
        } else {
          this.submitted = false;
         // response["message"] ? this.toastrService.error(response["message"]) : this.toastrService.error("Login Failed");
          swal.fire("Error", response["message"] ? response["message"] : "Login Failed", 'error');
          this.loginForm.reset();
        }
      },
      error => {
        swal.fire("Error", "Backend serveris not running", 'error');
      }) 
      /* this.http.get(CommonConstants.env + 'api/master/image/' +CommonConstants.PARTNER_ORGANISM_TYPE+'/'+localStorage.getItem(CommonConstants.USER_ORGANISM)).subscribe(res => {
        if (res['code'] == 'S0000') {
          let response = res['result'];
          if (response['image'] != null) {
            localStorage.setItem("ORG_LOGO", 'data:image/png;base64,' + response['image']);
          } else {
            localStorage.setItem("ORG_LOGO", '');
          }
        } else {
          localStorage.setItem("ORG_LOGO", '');
        }

      }) */
      /* this.loginAuthenticate.emit(this.authenticated)
      this.router.navigate(['myspace']);
      localStorage.setItem(CommonConstants.ACCESS_TOKEN,"sdfsdfsd");
          localStorage.setItem(CommonConstants.REFRESH_TOKEN, "dfsfsdfsdfdsfdsfsd");
          localStorage.setItem(CommonConstants.EXPIRES_IN, "56425"); */
     //this.loginAuthenticate.emit(this.authenticated)
     //this.router.navigate(['dashboard']);
  }
  resetPassword(){
    this.resetPswd=new ChangePassword();
    if(this.f.username.value==null || this.f.username.value==''){
      swal.fire("Error", "Please Enter User Name", 'error');
      return;
    }
    swal.fire({
      title: 'Reset password confirmation',
      text: 'Do you want reset your password for user '+ this.f.username.value+' Please Confirm!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, reset it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.resetPswd.secUsrLogin=this.f.username.value;
    this.http.post(CommonConstants.env + 'api/user/resetPassword', this.resetPswd).
      subscribe(response => {
        if (response['code'] == 0) {
          swal.fire('Saved!', "Password has been reset and shared to email", 'success')
        } else {
          swal.fire("Error", response['message'], 'error');
        }
      },
      error => {
        swal.fire("Error", "An Exception occurred, Please contact System Administrator", 'error');
      })   
      } else if (result.dismiss === swal.DismissReason.cancel) {
      }
    })
  }
  errorHandler(error: any): void {
    throwError(error);
  };


}
